import { apiGet, apiPost } from '@/lib/http/client';
import type { UserPreferenceRow } from '@/types/userPreferences';

/** GET /api/orgs/{orgId}/preferences/ — bare array, no pagination envelope. */
export async function fetchUserPreferences(
  orgId: number,
  signal?: AbortSignal
): Promise<UserPreferenceRow[]> {
  return apiGet<UserPreferenceRow[]>(
    `/api/orgs/${orgId}/preferences/`,
    undefined,
    10_000,
    signal
  );
}

/**
 * POST /api/orgs/{orgId}/preferences/ — upsert one preference row. The
 * server returns 201 (created) or 200 (updated) — both are success. There
 * is no DELETE route: clear a preference by calling this with `value: null`.
 */
export async function upsertUserPreference(
  orgId: number,
  body: { key: string; scope: string; value: unknown }
): Promise<UserPreferenceRow> {
  return apiPost<UserPreferenceRow>(
    `/api/orgs/${orgId}/preferences/`,
    body,
    10_000
  );
}
